import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { updateProjectName } from '@/features/projects/project-details/api/update-project-name';
import { useToast } from '@/shared/hooks/use-toast';

export const useUpdateProjectName = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('project', { keyPrefix: 'Shared' });

  return useMutation({
    mutationFn: updateProjectName,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projects'] });
      toast({ title: t('project_name_saved') });
    },
    onError: () => {
      toast({
        title: t('project_name_error'),
        variant: 'destructive',
      });
    },
  });
};
